<template>
  <div class="share-dialog">
    <div class="m-4">
      <div>Share it with your friends!</div>
      <div class="mx-auto text-center">
        <button
          type="button"
          class="btn m-2"
          v-clipboard:copy="url"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
        >Copy</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  page: 'dialog',
  props: ['url', 'text', 'title', 'poster'],
  methods: {
    onCopy: function (e) {
      document.getElementById('urlInput').focus()
    },
    onError: function (e) {
      alert('Failed to copy url')
    }
  }
}
</script>
